import ListSubheader from '@mui/material/ListSubheader';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import { fetchSectors, removeSector } from '@/actions/sector';
import { notify } from '@/actions/ui';
import Dialog from '@/components/Dialog/Dialog';
import { debounce, normalizeSpace } from '@/utils';

import ListItems from '../ListItems';
import SectorModel from './SectorModel';

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 0,
  },
  search: {
    marginLeft: 'auto',
    // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
      width: 190,
    },
  },
}));

export default function SectorModels({
  fetchSectors,
  removeSector,
  notify,
  sectors,
  model,
  id,
}: any) {
  const s = useStyles();
  const navigate = useNavigate();

  const [nameSearch, setNameSearch] = useState('');
  const [deleteTarget, setDeleteTarget] = useState<{
    id: number;
    name: string;
  } | null>(null);

  useEffect(() => {
    if (!id) {
      fetchSectors().catch((error: any) => {
        notify(error.message, 'error');
      });
    }
  }, [id]);

  const handleDelete = async (sector: any) => {
    try {
      await removeSector(sector.id);
      setDeleteTarget(null);
    } catch (error) {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      notify(error.message, 'error');
      return;
    }
    notify('Deleted Successfully');
  };

  const items = sectors
    .filter(
      (sector: any) =>
        sector.name.toLowerCase().indexOf(nameSearch) > -1 || sector.id.toString() === nameSearch
    )
    .map((sector: any) => ({
      id: sector.id,
      name: `${sector.id} ${sector.name}`,
    }));

  const searchHeader = (
    <ListSubheader disableSticky className={s.header}>
      <div className={s.search}>
        <TextField
          value={nameSearch ?? ''}
          fullWidth={false}
          onChange={({ target: { value } }) => {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
            debounce(setNameSearch(normalizeSpace(value)), 250);
          }}
          placeholder="Filter by name or ID"
        />
      </div>
    </ListSubheader>
  );

  return id ? (
    <SectorModel model={model} id={id !== 'new' ? id : undefined} />
  ) : (
    // @ts-expect-error TS(2339) FIXME: Property 'root' does not exist on type 'ClassNameM... Remove this comment to see the full error message
    <div className={s.root}>
      <ListItems
        model={model}
        items={items}
        onCreate={() => navigate(`/admin/${model.path}/new`)}
        onDelete={(sector: any) => setDeleteTarget(sector)}
        editEnabled={false}
        additionalHeaders={[searchHeader]}
      />
      <Dialog
        open={deleteTarget !== null}
        fullWidth
        maxWidth="sm"
        confirmLabel="Remove"
        onConfirm={() => handleDelete(deleteTarget)}
        cancelLabel="Cancel"
        onCancel={() => setDeleteTarget(null)}
      >
        Are you sure? This will remove sector {deleteTarget?.name}.
      </Dialog>
    </div>
  );
}

// @ts-expect-error TS(2630) FIXME: Cannot assign to 'SectorModels' because it is a fu... Remove this comment to see the full error message
SectorModels = connect(
  (state) => {
    return {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      sectors: state.sectors.all || [],
    };
  },
  {
    fetchSectors,
    removeSector,
    notify,
  }
)(SectorModels);
